export const USER_AGREEMENT_LINK =
  "https://docs.google.com/document/d/1vZ0r95PCh5xza9z_R1jColHa4pff2jbw5VKZrxVi87c/edit?tab=t.0";
